export const environment = {
  production: true,
  env: 'preprod',
  groups: {
    admin: 'XAZ-CERBERUS_ADMIN_PPROD',
    user: 'XAZ-CERBERUS_USER_PPROD',
    lead: 'XAZ-CERBERUS_LEAD_PPROD',
  },
  apiGatewayUrl: 'https://cerberus-preprod.api.nprd-astrazeneca.com/',
};
